import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nw-user-chip',
  templateUrl: './user-chip.component.html',
  styleUrls: ['./user-chip.component.scss']
})
export class NewellUserChipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
